import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { OrderState } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'PaymentOrderStatus',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { t } = useI18nTl('Base')



const statusLabel = computed(() => {
  switch (props.state) {
    case OrderState.OS_INIT: // 业务初始化状态(改成1,避免0值问题)
      return t('Base.stateInit')
    case OrderState.OS_WAIT: // 业务等待处理
      return t('Base.stateWait')
    case OrderState.OS_PROCESS: // 业务处理中
      return t('Base.stateProcess')
    case OrderState.OS_ABNORMAL: // 业务处于未知异常状态，等待进一步处理
      return t('Base.stateAbnormal')
    case OrderState.OS_CLOSE: // 订单关闭, 订单异常，不产生订单金额
      return t('Base.stateClose')
    case OrderState.OS_FINISH: // 业务正常完成
      return t('Base.stateFinish')
  }
  return t('Base.unknown')
})

// const statusTips = computed(() => {
//   return tl('chargingState')
// })

const color = computed(() => {
  switch (props.state) {
    case OrderState.OS_CLOSE:
      return '#EB4E3D'
  }
  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, { placement: "top" }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: "text-status",
        style: _normalizeStyle({ color: _unref(color) })
      }, _toDisplayString(_unref(statusLabel)), 5)
    ]),
    _: 1
  }))
}
}

})